import { useEffect } from 'react';
import { setSessionContext } from 'lib/error.utils';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { AuthPages } from 'lib/types/types';
import { isUserIdle } from 'lib/client/monitorActivity';
import { doSignout } from 'lib/client/signoutUtils';

export const SessionMonitor: React.FC = () => {
    const session = useSession();
    const userSession = session.data;
    const router = useRouter();
    useEffect(() => {
        if (!userSession) {
            return;
        }
        setSessionContext({
            customer_id: userSession.customerId,
            user_id: userSession.user?._id,
            session_id: userSession.sessionId
        });
    }, [userSession]);

    useEffect(() => {
        if (userSession?.error === 'RefreshAccessTokenError') {
            doSignout();
        } else if (userSession?.error === 'TokenExpiredError') {
            if (isUserIdle()) {
                doSignout();
            } else {
                router.push(AuthPages.signIn);
            }
        }
    }, [userSession, router]);
    return null;
};
